import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  email: {
    composes: ['fs12', 'mb12'],
    lineHeight: 0.9,
  },
  infos: {
    composes: ['text-center'],
    letterSpacing: 0.02,
  },
  name: {
    composes: ['is-bold', 'fs16', 'mb6'],
  },
});

const UserInfosComponent = ({ email, name }) => {
  const classes = useStyles();
  return (
    <div className={classes.infos}>
      {name && (
        <div className={classnames(classes.name, 'smart-maps-profile-name')}>
          {name}
        </div>
      )}
      {email && (
        <div className={classnames(classes.email, 'smart-maps-profile-email')}>
          {email}
        </div>
      )}
    </div>
  );
};

UserInfosComponent.propTypes = {
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default UserInfosComponent;
